var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _vm.dto.banner
        ? _c("banner", {
            attrs: { title: _vm.dto.banner, "custom-class": "bg-warning" },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "d-flex flex-row justify-content-between align-items-center",
        },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12 mt-2" }, [
              _c("h1", { domProps: { textContent: _vm._s(_vm.dto.title) } }),
              _vm._v(" "),
              _vm.dto.subTitle
                ? _c("h2", {
                    domProps: { textContent: _vm._s(_vm.dto.subTitle) },
                  })
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _vm.digitalCartTooltip
            ? _c("div", [
                _c("div", { staticClass: "row justify-content-end" }, [
                  _c(
                    "div",
                    { staticClass: "col-auto" },
                    [
                      _c("digital-cart-tooltip", {
                        attrs: {
                          title: _vm.digitalCartTooltip.title,
                          content: _vm.digitalCartTooltip.content,
                          "cta-label": _vm.digitalCartTooltip.ctaLabel,
                          "cta-url": _vm.digitalCartTooltip.cartPageUrl,
                          "empty-cart": _vm.digitalCartTooltip.emptyCart,
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row justify-content-center" },
        [
          _vm.topEligibilityResult
            ? _c(
                "form",
                {
                  attrs: {
                    id: "tester-eligibilite",
                    name: "tester-eligibilite",
                    method: "post",
                    action: _vm.topEligibilityResult.elipiUrl,
                  },
                },
                [
                  _c("input", {
                    attrs: { type: "hidden", name: "token" },
                    domProps: { value: _vm.token },
                  }),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.topEligibilityResult
            ? _c("EligibilityResult", {
                attrs: { "eligibility-result": _vm.topEligibilityResult },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.offerPackages
            ? [
                _vm._l(_vm.offerPackages, function (offerPackage, index) {
                  return _c(
                    "div",
                    { staticClass: "col-12 col-md-6 col-xl-4" },
                    [
                      _c("internet-and-mobile-card", {
                        key: "internet_and_mobile_pack_" + index,
                        attrs: {
                          banner: offerPackage.banner,
                          "pack-summary": offerPackage.packSummary,
                          "mobile-offer": offerPackage.mobileOffer,
                          "internet-offer": offerPackage.internetOffer,
                        },
                      }),
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _vm.dto.faq
                  ? _c(
                      "div",
                      { staticClass: "container-fluid pt-3 px-2" },
                      [
                        _c("showcase-faq", {
                          attrs: {
                            "faq-title": _vm.dto.faq.faqTitle,
                            "faq-list-of-attributes":
                              _vm.dto.faq.faqListOfAttributes,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            : _vm._l(2, function (index) {
                return _c(
                  "div",
                  { key: index, staticClass: "col-12 col-md-6 col-xl-4" },
                  [_c("skeleton-internet-and-mobile-card")],
                  1
                )
              }),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12 bg-gray2 py-2 px-2" },
          [
            _vm.legalMentions
              ? [
                  _c(
                    "link-fold-un-fold",
                    {
                      attrs: {
                        "collapsed-block-id": "legalMention",
                        "button-label": _vm.legalMentions.title,
                        "button-id": "'legal-mentions-button'",
                        "is-collapsed": false,
                      },
                    },
                    [
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(_vm.legalMentions.htmlContent),
                        },
                      }),
                    ]
                  ),
                ]
              : _vm._e(),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 mt-1" },
          [
            _c("breadcrumb", {
              attrs: {
                "aria-label": "Fil d'ariane",
                label: _vm.dto.breadcrumb.lastElementLabel,
                "breadcrumb-items": _vm.dto.breadcrumb.rootLinks,
              },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }